module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-lock-a13d4c3f.svg";